<template>
  <a-range-picker
    v-bind="attrs"
    :placeholder="integratePlaceholder"
    :class="[bem.b(), bem.is(isGray ? 'gray-date-range' : '')]"
  >
    <template
      v-for="item in Object.keys($slots).filter((slot) => slot !== 'separator')"
      #[item]="data"
    >
      <slot :name="item" v-bind="data || {}"></slot>
    </template>

    <template
      v-if="$slots.separator || separatorIcon || separatorText"
      #separator
    >
      <slot v-if="$slots.separator" name="separator" />
      <template v-else>
        <ll-icon v-if="separatorIcon" :icon-name="separatorIcon" />
        <span v-else>{{ separatorText }} </span>
      </template>
    </template>
  </a-range-picker>
</template>

<script lang="ts" setup>
import { createNamespace } from '@ll-plus/utils'
import { computed, useAttrs } from 'vue'
import { dateRangeProps } from './date-range'

defineOptions({ name: 'LlDateRange' })

const attrs = useAttrs()
const bem = createNamespace('date-range')

const props = defineProps(dateRangeProps)

const integratePlaceholder = computed(() => {
  return [
    props.startPlaceholder || props.placeholder?.[0],
    props.endPlaceholder || props.placeholder?.[1],
  ]
})
</script>
